import React from "react";
import { useRouteError, useNavigate } from "react-router-dom";

const ErrorFallback = () => {
  const error = useRouteError(); // React Router에서 에러 가져오기
  const navigate = useNavigate();

  const handleReset = () => {
    navigate("/"); // 홈으로 이동
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-20 bg-white">
      <h2 className="text-24 font-bold leading-[28px] tracking-[0.02px] mb-16">
        에러가 발생했습니다.
      </h2>
      <p className="text-14 leading-[20px] tracking-[0.014px] mb-32">
        {error?.message ||
          error?.statusText ||
          "알 수 없는 오류가 발생했습니다."}
      </p>
      <div className="mb-32">
        <h3 className="text-18 font-medium leading-[20px] tracking-[0.014px] mb-16">
          공공 API 오류
        </h3>
        <div>
          <a
            href="https://forms.gle/WsJ7PdSEiC6d4X9Y8"
            alt=""
            target="_blank"
            rel="noreferrer"
          >
            <button
              type="button"
              className="py-7 px-10 rounded-12 w-full border-1 border-gray-8 bg-white text-center text-gray-1 text-12 font-bold leading-[16px] tracking-[0.06px]"
            >
              제보하기
            </button>
          </a>
        </div>
      </div>
      {/* 개발 모드에서만 상세 정보 표시 */}
      {process.env.NODE_ENV === "development" && error && (
        <div className="mb-32">
          <h3 className="text-18 font-medium leading-[20px] tracking-[0.014px] mb-16">
            🔍 개발자 정보 보기
          </h3>
          <div>
            <div>{error?.toString()}</div>
            {error?.stack && <div>{error.stack}</div>}
          </div>
        </div>
      )}
      <div className="">
        <button type="button" onClick={handleReset} className="underline">
          홈으로 돌아가기
        </button>
        <span className="mx-10">|</span>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="underline"
        >
          새로고침
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
